module.exports = __webpack_public_path__ + "img/PayamIbrahim-Mang.7b3d095b.jpg";